const STORAGE_VERSION = 1;

export function loadPlanningPageState(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || parsed.version !== STORAGE_VERSION) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function savePlanningPageState(storageKey, state) {
  try {
    localStorage.setItem(storageKey, JSON.stringify({
      version: STORAGE_VERSION,
      ...state,
    }));
  } catch {
    // ignore
  }
}

export function normalizeMultiFilter(value) {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .map((item) => String(item ?? '').trim())
    .filter(Boolean);
}

export function normalizeTextFilter(value, fallback = '') {
  if (typeof value === 'string') {
    return value;
  }

  if (value == null) {
    return fallback;
  }

  return String(value);
}

export function normalizePositiveNumberFilter(value, fallback) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : fallback;
}

export function normalizeYearMultiFilter(value, fallbackYear) {
  const current = new Date().getFullYear();
  const minYear = current - 1;
  const maxYear = current + 1;
  const raw = Array.isArray(value)
    ? value
    : (value != null && value !== '' ? [value] : []);
  const years = normalizeMultiFilter(raw)
    .map((item) => Number(item))
    .filter((year) => Number.isFinite(year) && year >= minYear && year <= maxYear)
    .map(String);

  if (years.length > 0) {
    return years;
  }

  return fallbackYear ? [String(fallbackYear)] : [];
}

export function normalizeDateFilter(value, fallback = '') {
  if (typeof value !== 'string') {
    return fallback;
  }

  return /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : fallback;
}
